<template>
  <div>
    <app-header></app-header>
    <h1 class="display-4 text-center">Password reset</h1>
    <div class="container-fluid w-50 mt-5 bg-light">
      <form @submit.prevent="pwreset">
        <div class="form-group">
          <label class="label">New Password</label>
          <input type="password" class="input form-control" @input="$v.form.password.$touch()" v-model.trim="form.password" />
          <div v-if="$v.form.password.$dirty">
            <div class="text-danger" v-if="!$v.form.password.required">Password is required!</div>
          </div>
        </div>

        <div class="form-group">
          <label class="label">Confirm password</label>
          <input type="password" class="input form-control" @input="$v.form.confirmpassword.$touch()" v-model.trim="form.confirmpassword" />
          <div v-if="$v.form.confirmpassword.$dirty">
            <div class="text-danger" v-if="!$v.form.confirmpassword.required">Password is required!</div>
            <div class="text-danger" v-if="!$v.form.confirmpassword.sameAsPassword">Passwords don't match</div>
          </div>
        </div>

        <div class="text-center">
          <button class="btn btn-primary mb-3" :disabled="loading" type="submit">Send
            <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <span v-if="loading" class="sr-only">Loading...</span>
          </button>
          <div v-if="errors != null">
            <div class="text-danger" v-for="e in errors" v-bind:key="e.code" >{{e.description}}</div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import AppHeader from "./AppHeader";
import {required, email, sameAs} from "vuelidate/lib/validators";
import store from '../../ClientApp/store';

export default {
  components: {
    AppHeader
  },
  data: function () {
    return {
      form: {
        password: '',
        confirmpassword: '',
        id: '',
        token: '',
      },
      errors: null
    }
  },
  validations: {
    form: {
      password: {
        required
      },
      confirmpassword: {
        required,
        sameAsPassword: sameAs('password')
      },
    }
  },
  methods: {
    pwreset() {
      this.$v.form.$touch();
      if (this.$v.form.$error) return
      const payload = {
        NewPassword: this.form.password,
        ConfirmPassword: this.form.confirmpassword,
        Id: this.$route.params.id,
        Token: this.$route.query.token
      };
      this.$store
        .dispatch("pwchange", payload)
        .then(() => {
          this.error = null;
          this.form.password = "";
          this.form.confirmpassword = "";
          this.$router.push("/login");
        })
        .catch(error => {
            this.errors = error.data;
        });
      }
  },
  computed: {
    loading() {
      return this.$store.state.loading;
    },
    id() {
      return this.$route.params.id;
    },
    token() {
      return this.$route.query.token;
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/components/intro/PasswordInput.vue